import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { TASK_SUB_CATEGORY_API } from "../apiRoutes";

const mutateDeleteSubCategory = async ({ id }: { id: string }) => {
  return await axiosAuth.delete(`${TASK_SUB_CATEGORY_API}/${id}`);
};

const useDeleteSubCategoryMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteSubCategory,
    ...queryParams,
  });

export default useDeleteSubCategoryMutation;
